import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenMessage'
})
export class ShortenMessagePipe implements PipeTransform {
  transform(value: string, limit: number = 6, trail: string = '.....'): string {
    if (!value) {
      return '';
    }

    // Option 1: Using word limit by splitting words
    const words = value.split(/\s+/); // Split the string by whitespace characters

    if (words.length > limit) {
      return words.slice(0, limit).join(' ') + trail;
    } else {
      return value;
    }

  }

}
